<template>
  <div class="h-dialogContainer">
    <form id="uploadNoRealTaskDialog">
      <div class="row h-row-inputBox">
        <div class="col-sm-12 h-col-inputBox">
          <div class="h-inputLit">{{$t('Pm.startTime')}}:</div>
          <ejs-datetimepicker
            :format='dateFormat'
            :enabled='true'
            name="startTime"
            :locale='locale'
            v-model='startTime'
          ></ejs-datetimepicker>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-12 h-col-inputBox">
          <div class="h-inputLit">{{$t('Pm.endTime')}}:</div>
          <ejs-datetimepicker
            :format='dateFormat'
            :enabled='timeEnabled'
            name="endTime"
            :locale='locale'
            v-model='endTime'
          ></ejs-datetimepicker>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  export default {
    name: 'UploadNoRealTaskDialog',
    data() {
      return {
        timeEnabled:false,
        locale: localStorage.getItem('locale'),
        dateFormat: 'yyyy-MM-dd HH:mm:ss',
        // startTime: beforeTwoDay(),
        startTime: new Date(),
        endTime: new Date(),
      }
    },
    methods: {
     // 前两天
     beforeTwoDay() {
      let beforeTwoDay = new Date(
        this.endTime.getTime() -
          24 * 60 * 60 * 1000 -
          24 * 60 * 60 * 1000
      ); //计算当前日期 -2
      this.startTime = this.formatDateTime(beforeTwoDay); //格式化日期并赋值
      },
      formatDateTime(timeStamp) {
        var date = new Date();
        date.setTime(timeStamp);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        var h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        var minute = date.getMinutes();
        var second = date.getSeconds();
        minute = minute < 10 ? ('0' + minute) : minute;
        second = second < 10 ? ('0' + second) : second;
        return y + '-' + m + '-' + d+' '+h+':'+minute+':'+second;
    },
    },
  }
</script>

<style scoped>
</style>
